const { REACT_APP_BACK_URL } = process.env;

export const fieldTypes = [
  {
    id: 1,
    name: 'Text field (single line)',
    created_at: new Date(),
    updated_at: new Date(),
  },
  {
    id: 2,
    name: 'Text field (multi-line)',
    created_at: new Date(),
    updated_at: new Date(),
  },
  // {
  //   id: 3,
  //   name: 'Text field (rich)',
  //   created_at: new Date(),
  //   updated_at: new Date(),
  // },
  {
    id: 4,
    name: 'Number field',
    created_at: new Date(),
    updated_at: new Date(),
  },
  {
    id: 5,
    name: 'Date picker',
    created_at: new Date(),
    updated_at: new Date(),
  },
  {
    id: 6,
    name: 'Date/Time picker',
    created_at: new Date(),
    updated_at: new Date(),
  },
  {
    id: 7,
    name: 'URL field',
    created_at: new Date(),
    updated_at: new Date(),
  },
  {
    id: 8,
    name: 'Select list (single choice)',
    created_at: new Date(),
    updated_at: new Date(),
  },
  {
    id: 9,
    name: 'Select list (multiple choices)',
    created_at: new Date(),
    updated_at: new Date(),
  },
  {
    id: 10,
    name: 'Radio buttons',
    created_at: new Date(),
    updated_at: new Date(),
  },
  {
    id: 11,
    name: 'Checkboxes',
    created_at: new Date(),
    updated_at: new Date(),
  },
  // {
  //   id: 12,
  //   name: 'User picker',
  //   created_at: new Date(),
  //   updated_at: new Date(),
  // },
  // {
  //   id: 13,
  //   name: 'Group picker',
  //   created_at: new Date(),
  //   updated_at: new Date(),
  // },
  // {
  //   id: 14,
  //   name: 'Project picker',
  //   created_at: new Date(),
  //   updated_at: new Date(),
  // },
  // {
  //   id: 15,
  //   name: 'Version picker',
  //   created_at: new Date(),
  //   updated_at: new Date(),
  // },
  // {
  //   id: 16,
  //   name: 'Component picker',
  //   created_at: new Date(),
  //   updated_at: new Date(),
  // },
  // {
  //   id: 17,
  //   name: 'Issue picker / Issue link',
  //   created_at: new Date(),
  //   updated_at: new Date(),
  // },
];

export default REACT_APP_BACK_URL;
